import { styled } from "../../../../../styles";

export const HistoryList = styled("ol", {
  listStyle: "none",
  margin: "16px 0 0",
  padding: 0,
  maxHeight: "50vh",
  overflowY: "auto",
  fontFamily: "$openSans",
  fontSize: "14px",
  color: "$charcoal",

  li: {
    display: "grid",
    gridTemplateColumns: "170px 1fr auto",
    gap: "12px",
    alignItems: "baseline",
    padding: "10px 0",
    borderBottom: "1px solid $gray-40",
  },

  "li:last-child": { borderBottom: "none" },

  time: { color: "$gray-90" },
});

/** "History" beside the live line. */
export const HistoryLink = styled("button", {
  padding: 0,
  border: "none",
  background: "none",
  color: "$primary",
  fontFamily: "$openSans",
  fontSize: "13px",
  fontWeight: 600,
  textDecoration: "underline",
  cursor: "pointer",

  "&:focus-visible": { outline: "2px solid var(--colors-button-focus-border)" },
});
